import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { defaultLocale } from '../config/i18n.config';
import { LocaleProvider } from '../context/localeContext';
import ContactPage from './ContactPage';
import Layout from '../components/Layout';

const ContactPageTemplate = ({ data, pageContext }) => {
  const { frontmatter: page } = data.markdownRemark;

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <ContactPage
          title={page[pageContext.locale].title || page[defaultLocale].title}
          heroImage={page[defaultLocale].image}
          heroContent={
            page[pageContext.locale].hero || page[defaultLocale].hero
          }
          blocks={page[pageContext.locale].blocks || page[defaultLocale].blocks}
        />
      </Layout>
    </LocaleProvider>
  );
};

ContactPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ContactPageTemplate;

export const contactUsPageQuery = graphql`
  query ContactUsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        en {
          title
          image {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: BLURRED
                layout: FULL_WIDTH
              )
            }
          }
          hero
          blocks {
            colorScheme
            left
            overlayLength
            overlaySide
            right
          }
        }
        de {
          title
          hero
          blocks {
            colorScheme
            left
            overlayLength
            overlaySide
            right
          }
        }
      }
    }
  }
`;
